import * as React from 'react'

import type { Moment } from 'moment'
import ReactTooltip from 'react-tooltip'
import { WeeklyRestTooltip } from '../WeeklyRestTooltip'

type WeeklyRestTooltipRendererProps = {
  translate: (text) => any
  startTime: Moment
}

type WeeklyRestTooltipRendererState = {}

export default class WeeklyRestTooltipRenderer extends React.Component<
  WeeklyRestTooltipRendererProps,
  WeeklyRestTooltipRendererState
> {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <ReactTooltip
        id="weeklyRestTooltip"
        aria-haspopup="true"
        role="example"
        place="top"
        effect="float"
        key={'weeklyRestTooltip' + this.props.startTime}
        className="!tw-border-0 !tw-bg-transparent !tw-p-0 !tw-opacity-100 !tw-shadow-none"
        backgroundColor="transparent"
        border={false}
        borderColor="transparent"
        type="dark"
        offset={{ top: 10 }}
        getContent={(data) => {
          return data == null ? null : (
            <WeeklyRestTooltip
              weeklyRest={JSON.parse(data)}
              translate={this.props.translate}
            />
          )
        }}
        overridePosition={(
          { left, top },
          currentEvent,
          currentTarget,
          node,
        ) => {
          const d = document.documentElement

          left = Math.min(d.clientWidth - node.clientWidth, left)
          top = Math.min(d.clientHeight - node.clientHeight, top)
          left = Math.max(20, left)
          top = Math.max(0, top)

          return { top, left }
        }}
      />
    )
  }
}
